import { Icon } from '@iconify/react'
import { motion } from 'framer-motion'
import { useLocation, useNavigate, useParams } from 'react-router-dom'

import { useWatchList } from '@/context-state/WatchListContext.jsx'

import { AnalyticsService } from '@/services/analytics.js'

// The list of followed advertisers, rendered as nav rows. Collapse is owned
// by the parent section (CollapsibleNavSection) — this only renders the rows.
export const WatchedBrandsList = () => {

    const navigate = useNavigate()
    const { pathname } = useLocation()
    const { accountId, spaceId } = useParams()
    const { brands } = useWatchList()

    const brandsBase = `/account/${accountId}/space/${spaceId}/dashboard/intelligence/brands`
    const allAdvertisersHref = `/account/${accountId}/space/${spaceId}/dashboard/intelligence/watching/all`
    const isAllAdvertisersActive = pathname.includes('/intelligence/watching/all')

    if (brands.length === 0) {
        return (
            <div className="px-5 py-1.5 text-[13px] font-light text-muted-foreground">
                No advertisers yet
            </div>
        )
    }

    return (
        <div className="space-y-0.5 pl-4 pr-2 pb-2">
            {/* With more than one advertiser, the first row opens the hub
                that covers all of them. */}
            {brands.length > 1 && (
                <div
                    onClick={() => {
                        navigate(allAdvertisersHref)
                        AnalyticsService.track('navigate-to-watch-list-all-advertisers', { count: brands.length })
                    }}
                    data-intercom-target="sidebar-watch-list-all-advertisers"
                    className={`flex cursor-pointer items-center gap-2.5 rounded-lg px-3 py-1.5 transition-colors ${isAllAdvertisersActive ? 'bg-primary/10 text-primary' : 'hover:bg-accent'}`}
                >
                    <div className="flex h-6 w-6 shrink-0 items-center justify-center rounded bg-primary/15 text-primary ring-1 ring-inset ring-primary/40">
                        <Icon icon="lucide:layers" className="h-3.5 w-3.5" />
                    </div>
                    <span className="truncate text-[13px] font-light">All advertisers</span>
                </div>
            )}
            {brands.map((b, i) => {
                const isActive = pathname.includes(`/brands/${b.advertiser_id}`)

                return (
                    <motion.div
                        key={b.advertiser_id}
                        initial={{ opacity: 0, x: -10 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ delay: 0.02 * i, duration: 0.18 }}
                        onClick={() => {
                            navigate(`${brandsBase}/${b.advertiser_id}`)
                            AnalyticsService.track('navigate-to-watched-brand', { advertiser_id: b.advertiser_id })
                        }}
                        className={`flex cursor-pointer items-center gap-2.5 rounded-lg px-3 py-1.5 transition-colors ${isActive ? 'bg-primary/10 text-primary' : 'hover:bg-accent'}`}
                    >
                        {b.profile_picture_url ? (
                            <img
                                src={b.profile_picture_url}
                                alt=""
                                className="h-6 w-6 shrink-0 rounded object-cover"
                            />
                        ) : (
                            <div className="flex h-6 w-6 shrink-0 items-center justify-center rounded bg-muted text-[11px] font-medium text-muted-foreground">
                                {(b.display_name ?? '?').slice(0, 1)}
                            </div>
                        )}
                        <span className="truncate text-[13px] font-light">
                            {b.display_name ?? b.advertiser_id}
                        </span>
                    </motion.div>
                )
            })}
        </div>
    )
}
